var _g, _rect, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 150,
    viewBox: "0 0 260 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1024_9610)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 259.5,
    height: 150,
    rx: 8,
    fill: "#7647EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1024_9610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 260,
    height: 150
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 259.5,
    height: 150,
    rx: 8,
    fill: "#7647EE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1024_9610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.946 20.046L199.254 23.2827L197.493 10.4778L187.43 25.1323L172.732 27.4315L170.55 11.5694L180.607 -3.125L168.783 -1.27547L165.698 -23.708L212.912 -31.0934L219.946 20.046ZM204.565 15.5194L212.746 14.2397L207.579 -23.3266L172.891 -17.9005L174.109 -9.04116L194.801 -12.2778L177.191 13.3674L178.053 19.6338L183.839 18.7287L201.449 -6.91656L204.565 15.5194Z",
    fill: "url(#paint0_linear_1024_9610)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.001 57.8274L246.309 61.0641L244.548 48.2592L234.448 62.9194L219.779 65.2139L217.598 49.3599L227.656 34.6655L215.832 36.515L212.75 14.1064L259.972 6.71987L267.001 57.8274ZM251.62 53.3007L259.801 52.021L254.635 14.4627L219.946 19.8888L221.168 28.7722L241.86 25.5355L224.25 51.1807L225.111 57.4391L230.898 56.534L248.507 30.8887L251.62 53.3007Z",
    fill: "url(#paint1_linear_1024_9610)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.242 79.8372L194.55 83.0738L192.789 70.269L182.689 84.9292L168.02 87.2237L165.84 71.3697L175.934 56.6694L164.073 58.5248L160.991 36.1162L208.213 28.7296L215.242 79.8372ZM199.861 75.3105L208.042 74.0308L202.876 36.4725L168.188 41.8985L169.406 50.7579L190.098 47.5213L172.488 73.1665L173.349 79.4249L179.135 78.5197L196.745 52.8745L199.861 75.3105Z",
    fill: "url(#paint2_linear_1024_9610)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.704 -1.97098L251.012 1.2657L249.245 -11.5792L239.188 3.11523L224.482 5.41558L222.3 -10.4464L232.394 -25.1466L220.533 -23.2913L217.443 -45.7559L264.665 -53.1424L271.704 -1.97098ZM256.323 -6.49767L264.504 -7.77732L259.337 -45.3436L224.648 -39.9175L225.866 -31.0582L246.558 -34.2948L228.949 -8.64964L229.81 -2.38325L235.597 -3.28836L253.207 -28.9336L256.323 -6.49767Z",
    fill: "url(#paint3_linear_1024_9610)",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1024_9610",
    x: -143.5,
    y: -144,
    width: 547.5,
    height: 438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 72
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1024_9610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1024_9610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1024_9610",
    x1: 189.305,
    y1: -27.4007,
    x2: 197.281,
    y2: 23.5913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1024_9610",
    x1: 236.361,
    y1: 10.4132,
    x2: 244.332,
    y2: 61.3733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1024_9610",
    x1: 184.602,
    y1: 32.4229,
    x2: 192.573,
    y2: 83.3831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1024_9610",
    x1: 241.054,
    y1: -49.4491,
    x2: 249.036,
    y2: 1.5748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleBg);
export default __webpack_public_path__ + "static/media/purple-bg.09a51558175ad38ec60e6197be7c5614.svg";
export { ForwardRef as ReactComponent };